export default {
  sportsbook: "体育博彩代理",
  login_page: "体育博彩代理网站",
  first_time_page: "首次登入",
  security_page: "安全认证",
  account_settings: "账号设置",
  new_login: "新登入",
  two_step_verification: "两步验证",
  account_information: "账号信息",
  commission_settings: "佣金设置",
  bet_limit_settings: "投注限额设置",
  position_taking_settings: "PT（持仓）设置",
  update_profile: "更新个人资料",
  update_password: "更新密码",
  update_security: "更新安全性",
  account_profile: "账号资料",
  account_creation: "创建账号",
  profile_settings: "个人资料设置", 
};